export default "__VITE_ASSET__oQLrigU3__"